//import React from 'react';

const maxValue = max => value =>
  value && parseInt(value, 10) > max ? `Max value is ${max}` : undefined


export const number = value => value && isNaN(Number(value)) ? 'Must be a number' : undefined

export const maxValue100 = maxValue(100);
export const maxValue1 = maxValue(1);
export const maxValue2 = maxValue(2);
export const maxValue3 = maxValue(3);
export const maxValue4 = maxValue(4);
export const maxValue5 = maxValue(5);
export const maxValue6 = maxValue(6);
export const maxValue7 = maxValue(7);
export const maxValue8 = maxValue(8);
export const maxValue9 = maxValue(9);
export const maxValue10 = maxValue(10);
